import React, { FC } from 'react';

export const PauseIcon: FC = () => (
  <>
    <rect x={0} y={0.05} width={0.35} height={0.9} />
    <rect x={0.65} y={0.05} width={0.35} height={0.9} />
  </>
);
